export default __webpack_public_path__ + "static/viture_one_neckband_m-0afe9fcb3b3b65d0d5eb38979cbd25a5.png";